//import loggingService from './util/loggingService'
import dateService from '../services/util/dateService'

var path = '/CulturalResourceRecording/'

function get (http, id, loadComponents = true) {
    return http.get(path + `Get?culturalResourceRecordingId=${id}&loadComponents=${loadComponents}`)
}

function getProduction (http, id, loadComponents) {
    return http.get(path + `GetProduction?culturalResourceId=${id}&loadComponents=${loadComponents}`)
}

function getRecordingList (http, id) {
    return http.get(path + `getRecordingList?culturalResourceId=${id}`).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.completeDate = dateService.convertToDate(x.completeDate)
            })
        }
        return response
    })
}

function put (http, dto) {
    return http.put(path, dto)
}

function putInvestigationCrr (http, dto) {
    return http.put(path + 'PutInvestigationCrr', dto)
}

function putNotLocatedCrr (http, dto) {
    return http.put(path + 'putNotLocatedCrr', dto)
}

function putAttachmentSelection (http, attachmentSelectionDto) {
    return http.put(path + 'PutAttachmentSelection', attachmentSelectionDto)
}

function search (http, searchDto) {
    return http.post(path + 'Search', searchDto)
}

function searchSummary (http, searchDto) {
    return http.post(path + 'SearchSummary', searchDto)
}

function searchSummaryNotLocated (http, searchDto) {
    return http.post(path + 'searchSummaryNotLocated', searchDto)
}

function saveList (http, recordingList) {
    return http.post(path + 'SaveList', recordingList)
}

function getQaqcProgress (http, crrId) {
    return http.get(path + `getQaqcProgress?crrId=${crrId}`)
}

function putQaqcProgress (http, progressDto) {
    return http.put(path + 'putQaqcProgress', progressDto)
}

function getQaqcRecord (http, recordingCrrId, loadComponents, loadAttachmentSelections) {
    return http.get(path + `getQaqcRecord?recordingCrrId=${recordingCrrId}&loadComponents=${loadComponents}&loadAttachmentSelections=${loadAttachmentSelections}`)
}

function remove (http, crrId) {
    return http.delete(path + `Remove?crrId=${crrId}`)
}

function siteFormReportGen (http, crrId, siteTrsStringList) {
    return http.post(path + `SiteFormReportGen?crrId=${crrId}`, { siteTrsStringList: siteTrsStringList },
        {
            responseType: 'arraybuffer'
        }
    )
}

var RecordingTypeEnum = {
    FirstRecording: 1,
    FullRerecord: 2,
    Update: 3,
    ConditionReport: 4,
    SiteLead: 5,
    NotLocated: 6,
    OutsideAPE: 7,
    Migrated: 8,
    DeskReview: 9, //Desk Review 1
    MultiSmithNo: 10,
    NotRecorded: 11,
    InternalReview: 12, //Desk Review
    Normalization: 13
}

var ExcludedRecordingTypes = [
    RecordingTypeEnum.NotLocated,
    RecordingTypeEnum.OutsideAPE,
    RecordingTypeEnum.DeskReview,
    RecordingTypeEnum.MultiSmithNo,
    RecordingTypeEnum.NotRecorded
]

var TimePeriodEnum = {
    Prehistoric: 1,
    Protohistoric: 2,
    Historic: 3,
    Unknown: 4
}

var PropertyTypeEnum = {
    Site: 1,
    Building: 2,
    Structure: 3,
    Object: 4,
    District: 5,
    Landscape: 6,
    LithicLandscape: 7,
    TCP: 8
}

var WorkflowStatusEnum = {
    PendingDataEntry: 5000,
    PendingInvestigationSubmit: 5050,
    PendingAgencyApproval: 5100,
    PendingSHPOAssignment: 5150,
    PendingSHPOApproval: 5200,
    Concurrence: 5300,
    Denied: 5400,
    QaqcComplete: 5500
}

export default {
    get: get,
    getProduction: getProduction,
    getRecordingList: getRecordingList,
    put: put,
    putInvestigationCrr: putInvestigationCrr,
    search: search,
    saveList: saveList,
    TimePeriodEnum: TimePeriodEnum,
    PropertyTypeEnum: PropertyTypeEnum,
    RecordingTypeEnum: RecordingTypeEnum,
    ExcludedRecordingTypes: ExcludedRecordingTypes,
    WorkflowStatusEnum: WorkflowStatusEnum,
    putAttachmentSelection: putAttachmentSelection,
    searchSummary: searchSummary,
    getQaqcProgress: getQaqcProgress,
    putQaqcProgress: putQaqcProgress,
    getQaqcRecord: getQaqcRecord,
    remove: remove,
    siteFormReportGen: siteFormReportGen,
    searchSummaryNotLocated: searchSummaryNotLocated,
    putNotLocatedCrr: putNotLocatedCrr
}



// WEBPACK FOOTER //
// ./src/services/culturalResourceRecordingService.js